export default __webpack_public_path__ + "static/tmb-5-98ab188a75451a332397e840bc84ce3b.png";